import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#64C828',
        secondary: '#b0bec5',
        accent: '#8A3264',
        error: '#E45A5A'
      }
    }
  }
})
